import { Select } from "@mantine/core";
import type { Person } from "../../../../utils/backend-types";

type TodoPersonCellProps = {
  persons: Array<Person>;
  todoId: number;
  person: string | null;
  onChangePerson: (todoId: number, person: number) => void;
  notChangeable?: boolean;
};

function TodoPersonCell({
  notChangeable,
  persons,
  todoId,
  person,
  onChangePerson
}: TodoPersonCellProps) {
  const currentPerson = persons.find((p) => p.name === person);

  function handleChangePerson(_, value) {
    onChangePerson(todoId, value);
  }

  return (
    <div className="todo-person-cell-container">
      {notChangeable ? (
        <div>{currentPerson?.name}</div>
      ) : (
        <Select
          data={persons.map((person) => ({
            value: person.id.toString(),
            label: person.name
          }))}
          defaultValue={currentPerson?.id.toString()}
          onChange={(newValue: string | null) =>
            handleChangePerson(todoId, newValue ? parseInt(newValue) : null)
          }
        />
      )}
    </div>
  );
}

export { TodoPersonCell };
